<template>
    <v-text-field
        v-model="message"
        placeholder="Write your message here!!!"
        outlined
        rounded
        prepend-inner-icon="mdi-emoticon-outline"
        append-icon="mdi-paperclip"
        append-outer-icon="mdi-send"
        @click:append-outer="sendMessage"
        @keydown.enter="sendMessage"></v-text-field>
</template>
<script>
// import moment from 'moment'
export default {
    data: () => ({
        message: ''
    }),
    methods: {
        sendMessage() {
            let formData = new FormData()
            const data = {
                driver: "web",
                userId:  +new Date(),
                message: this.message,
                attachment: null,
                interactive: null, // interactive,
                attachment_data: null
            }
            // const data = {
            //     author: 'user',
            //     action: null,
            //     message: this.message,
            //     time: new moment().locale('ve').format('hh:mm:ss a')
            // }


            Object.keys(data).forEach(key => formData.append(key, data[key]));
            this.$store.dispatch('message/sendMessage', data)
            this.message = ''
        }
    }
}
</script>